// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Sllxz","requiredAsterisk":"Info_requiredAsterisk__27MeR"};